import { ModalWindow, Button } from '@cian/ui-kit';
import * as React from 'react';

import { CalltrackingWarning } from '../CalltrackingWarning';

export interface IPhoneButtonProps {
  isCalltrackingEnabled?: boolean;
  text?: string;
  onClick(): void;
}

export function PhoneButton({ isCalltrackingEnabled, text = 'Позвонить', onClick }: IPhoneButtonProps) {
  const [showCalltrackingWarning, setShowCalltrackingWarning] = React.useState<boolean>(false);

  const closeWarning = () => {
    setShowCalltrackingWarning(false);
  };

  const openWarning = () => {
    setShowCalltrackingWarning(true);
  };

  const clickHandler = React.useCallback(() => {
    onClick();
  }, [onClick]);

  const clickHandlerWithWarning = React.useCallback(() => {
    clickHandler();
    setShowCalltrackingWarning(false);
  }, [clickHandler]);

  return (
    <>
      <Button
        data-testid="PhoneButton"
        fullWidth
        onClick={isCalltrackingEnabled ? openWarning : clickHandler}
        theme="fill_primary"
        size="M"
      >
        {text}
      </Button>
      <ModalWindow
        content={<CalltrackingWarning onClick={clickHandlerWithWarning} />}
        open={showCalltrackingWarning}
        fixed={false}
        onClose={closeWarning}
        size="M"
      />
    </>
  );
}
